const buttons = document.querySelectorAll("[data-toggle-note]");

buttons.forEach(btn => {
  btn.addEventListener("click", () => {
    // Close all note/discount boxes first
    document.querySelectorAll(".add_note_box").forEach(b => b.classList.remove("active"));

    const target = btn.hasAttribute("data-note-box")
      ? ".add_note_box[data-note-box]"
      : ".add_note_box[data-discount-box]";

    const targetBox = document.querySelector(target);
    if (targetBox) {
      targetBox.classList.add("active");
    }
  });
});

document.querySelectorAll("[data-close-note]").forEach(close =>
  close.addEventListener("click", () =>
    close.closest(".add_note_box").classList.remove("active")
  )
);

// ------------------ Start: Custom Quantity Selector for prouct page bottom sticky bar -------------------
function initSimpleQtySelectors() {
  document.querySelectorAll('.js-qty__wrapper').forEach(function (wrapper) {
    var input = wrapper.querySelector('.js-qty__num');
    var minus = wrapper.querySelector('.custom_quantity_minus');
    var plus = wrapper.querySelector('.custom_quantity_plus');

    if (!input || !minus || !plus) return;

    var min = parseInt(input.getAttribute('min')) || 1;

    // Initial value fallback
    if (!input.value || isNaN(parseInt(input.value))) {
      input.value = min;
    }

    plus.addEventListener('click', function () {
      var current = parseInt(input.value) || min;
      input.value = current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minus.addEventListener('click', function () {
      var current = parseInt(input.value) || min;
      if (current > min) {
        input.value = current - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    input.addEventListener('input', function () {
      var val = parseInt(input.value);
      if (isNaN(val) || val < min) {
        input.value = min;
      }
    });
  });
}

// DOM ready / section load par call karo
document.addEventListener('DOMContentLoaded', initSimpleQtySelectors);
// ------------------ End: Custom Quantity Selector for prouct page bottom sticky bar -------------------


// Recomendation on cart drawer --------------------------------------------
document.addEventListener('cart-drawer:refreshed', async () => {
 const productID = await getFirstProductID();
  if (productID) {
    updateRecomandationProducts(productID);
  }
});

document.addEventListener('DOMContentLoaded', async () => {
 const productID = await getFirstProductID();
  if (productID) {
    updateRecomandationProducts(productID);
  }

  // Initialize remove item buttons
  initializeRemoveButtons();

  // Initialize drawer close handler
  initializeDrawerCloseHandler();

  // Initialize checkout button
  initializeCheckoutButton();

  // Initialize discount box close handlers
  initializeDiscountBoxHandlers();
});

// Add event listeners for remove buttons
function initializeRemoveButtons() {
  document.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('.remove-item-button');
    if (removeBtn) {
      e.preventDefault();
      const lineKey = removeBtn.getAttribute('data-line-key');
      if (lineKey) {
        await removeCartItem(lineKey);
      }
    }
  });
}

// Remove cart item function - FULLY FIXED VERSION
async function removeCartItem(lineKey) {  
  try {
    // Show loading state
    const itemElement = document.querySelector(`[data-line-key="${lineKey}"]`);
    if (itemElement) {
      itemElement.style.opacity = '0.5';
      itemElement.style.pointerEvents = 'none';
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    });

    if (response.ok) {
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));
      // CRITICAL: Force full cart drawer rebuild
      // if (window.theme && window.theme.cartForm) {
      //   console.warn('Cart drawer rebuild triggered theme', window.theme);
      //   console.warn('Cart drawer rebuild triggered', window.theme.cartForm);
      //   // Use immediate execution - no timeout
      //   window.theme.cartForm.buildCart();
      //   // Update displays after build completes
      //   setTimeout(() => {
      //     updateAllCartDisplays(cart);
      //   }, 300);
      // }
      // Update recommendations
      setTimeout(async () => {
        const productID = await getFirstProductID();
        if (productID) {
          updateRecomandationProducts(productID);
        } else {
          const recSection = document.querySelector('.product-recommendations');
          if (recSection) {
            recSection.innerHTML = '';
          }
        }
      }, 400);

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('cart:itemRemoved', {
        bubbles: true,
        detail: { cart: cart, removedKey: lineKey }
      }));
    }
  } catch (error) {
    console.error('Error removing item:', error);
    alert('Failed to remove item. Please try again.');
    // Restore item visibility
    const itemElement = document.querySelector(`[data-line-key="${lineKey}"]`);
    if (itemElement) {
      itemElement.style.opacity = '1';
      itemElement.style.pointerEvents = 'auto';
    }
  }
}

const getFirstProductID = async function () {
  const cartResponse = await fetch('/cart.js');
  const cartTemp = await cartResponse.json();
  if (cartTemp.items && cartTemp.items.length > 0) {
      return cartTemp.items[0].product_id;
    }
    return null;
}

const updateRecomandationProducts = function (productID) {
  let productRecommendationsSection = document.querySelector('.product-recommendations');
  if (!productRecommendationsSection) return;

  fetch(window.Shopify.routes.root + "recommendations/products?product_id=" + productID + "&section_id=os_product-recommendations&intent=related")
    .then(response => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('#product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;

        let recommenDationswiper = new Swiper(".recommendation-swiper", {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        const recContainer = document.querySelector('.product-recommendations');
        if (!recContainer) {
          return;
        }
        recContainer.addEventListener('click', (event) => {
          const button = event.target.closest('.recommendation_add_to_cart');
          if (button) {
            event.preventDefault();
            const variantId = button.dataset.variantId;
            if (variantId) {
              handleAddToCart(variantId, button);
            }
          }
        });
      }
    });
}

const handleAddToCart = async function (variantId, button) {
  button.disabled = true;

  const formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response from Cart API:', errorData);
      throw new Error(errorData.description || 'Failed to add item');
    }
    const cartData = await response.json();

    // Trigger cart rebuild
    if (window.theme && window.theme.cartForm) {
      window.theme.cartForm.buildCart();
      setTimeout(() => {
        updateAllCartDisplays(cartData);
      }, 300);
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      detail: { product: cartData, addedFrom: 'recommendations' }
    }));

  } catch (error) {
    console.error('Error in handleAddToCart:', error);
    button.disabled = false;
  }
}


// ---------------- Discount Code Management ----------------
// NOTE: Discount functionality is now handled by cart-discount.js
// This file only keeps the drawer close handler initialization

// Initialize discount box close handlers - kept for compatibility
function initializeDiscountBoxHandlers() {
  // Discount box handlers are now in cart-discount.js
  // This function is kept empty for backward compatibility
}

// ---------------- Add Note On Cart Drawer ----------------
const noteSaveBtn = document.querySelector('[data-note-save]');
const noteCancelBtn = document.querySelector('[data-note-cancel]');
const noteInput = document.querySelector('[data-cart-note-input]');
let originalNote = noteInput ? noteInput.value : '';

// Save note button
if (noteSaveBtn) {
  noteSaveBtn.addEventListener('click', async () => {
    const noteValue = noteInput ? noteInput.value.trim() : '';

    try {
      noteSaveBtn.disabled = true;
      noteSaveBtn.textContent = 'Saving...';

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: noteValue })
      });

      const cart = await response.json();

      if (!response.ok) {
        throw new Error('Failed to save note.');
      }

      originalNote = noteValue;
      noteSaveBtn.textContent = 'Saved!';

      setTimeout(() => {
        const noteBox = document.querySelector('.add_note_box[data-note-box]');
        if (noteBox) {
          noteBox.classList.remove('active');
        }
        noteSaveBtn.textContent = 'Save';
      }, 1000);

    } catch (error) {
      console.error('Note Error:', error);
      alert('Failed to save note. Please try again.');
      noteSaveBtn.textContent = 'Save';
    } finally {
      noteSaveBtn.disabled = false;
    }
  });
}

// Cancel note button
if (noteCancelBtn) {
  noteCancelBtn.addEventListener('click', () => {
    if (noteInput) noteInput.value = originalNote;
    const noteBox = document.querySelector('.add_note_box[data-note-box]');
    if (noteBox) {
      noteBox.classList.remove('active');
    }
  });
}

// Helper function to update discount display - NOW HANDLED BY cart-discount.js
// Kept for compatibility but redirects to CartDiscount
function updateDiscountDisplay(cart) {
  if (window.CartDiscount && window.CartDiscount.updateDisplay) {
    window.CartDiscount.updateDisplay(cart);
  }
}

// Helper function to format money
function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
    return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
  }
  return '$' + (cents / 100).toFixed(2);
}



// Helper function to update checkout button
function updateCheckoutButton(cart) {
  const checkoutBtn = document.querySelector('.cart__checkout');
  if (!checkoutBtn || !cart) return;

  checkoutBtn.innerHTML = `Checkout`;
}

// Helper function to update all cart displays
function updateAllCartDisplays(cart) {
  if (!cart) return;

  try {
    // Update subtotal
    const subtotalElement = document.querySelector('[data-subtotal]');
    if (subtotalElement) {
      const originalTotal = cart.original_total_price || cart.items_subtotal_price || cart.total_price;
      subtotalElement.innerHTML = formatMoney(originalTotal);
    }

    // Update discount display
    updateDiscountDisplay(cart);

    // Update final total
    const finalTotalElement = document.querySelector('[data-final-total]');
    if (finalTotalElement) {
      finalTotalElement.innerHTML = formatMoney(cart.total_price);
    }

    // Update checkout button
    updateCheckoutButton(cart);

    // Update note if exists
    if (noteInput && cart.note) {
      originalNote = cart.note;
    }
  } catch (error) {
    console.error('Error updating cart displays:', error);
  }
}

// Initialize drawer close handler
function initializeDrawerCloseHandler() {
  const drawerCloseBtn = document.querySelector('.js-drawer-close');
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', () => {
      document.querySelectorAll('.add_note_box').forEach(box => {
        box.classList.remove('active');
      });
      // if (discountMessage) discountMessage.textContent = '';
      if (discountInput) discountInput.value = '';
    });
  }
}

// Initialize checkout button on page load
async function initializeCheckoutButton() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    updateAllCartDisplays(cart);
  } catch (error) {
    console.error('Error initializing cart displays:', error);
  }
}

// Event listeners for cart updates
// NOTE: cart:updated and cart:build are now handled by cart-discount.js
// Keep only essential ones here

document.addEventListener('cart:refresh', async (event) => {
  if (event.detail && event.detail.cart) {
    updateAllCartDisplays(event.detail.cart);
  }
});

document.addEventListener('cart-drawer:refreshed', async () => {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    updateAllCartDisplays(cart);
  } catch (error) {
    console.error('Error updating cart displays:', error);
  }
});

// Listen for product added from product page and rebuild cart drawer
// document.addEventListener('ajaxProduct:added', async (event) => {
//   // Wait a moment for the cart to be updated on server side
//   await new Promise(resolve => setTimeout(resolve, 200));

//   // Rebuild the cart drawer to show the newly added product
//   if (window.theme && window.theme.cartForm) {
//     window.theme.cartForm.buildCart();

//     // Update displays after rebuild
//     setTimeout(async () => {
//       try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         updateAllCartDisplays(cart);

//         // Update recommendations
//         const productID = await getFirstProductID();
//         if (productID) {
//           updateRecomandationProducts(productID);
//         }
//       } catch (error) {
//         console.error('Error updating cart after product add:', error);
//       }
//     }, 300);
//   }
// });